"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradePaths = exports.EMBEDDED_AD_URL_SLUG_TO_UPGRADE_CARD_TYPE_MAP = exports.UPGRADE_CARD_TYPE_TO_EMBEDDED_AD_URL_SLUG_MAP = exports.GenericMoapVideoInterstitialTrustBuilderComponent = exports.BalanceDetailsBeardUpgradeUIVariant = exports.BalanceDetailsBeardVariant = exports.UpgradeCardAttributeRecord = exports.UpgradeCardOfferType = exports.isUpgradeSource = exports.UPGRADE_SOURCE_VALUES = exports.UpgradeSourceUnknown = exports.UpgradeBackgroundProcess = exports.UpgradeOpsEndpoint = exports.UpgradePage = exports.UpgradeCardTypeDeprecated = exports.UpgradeCardType = exports.UpgradeCardFootnoteType = exports.StatedUsageAmountType = exports.LoanApplicationCreationType = exports.NewLoanApplicationFillInInfo = exports.TargetToMarkAsDuplicate = exports.boostNetWorthV0UtmCampaign = exports.getMoneyWithOneYearOfStarbucksCustomAmount = exports.getMoneyWithOneYearOfStarbucksFixedAmount = exports.getMoneyCustomAmount = exports.getMoneyFixedAmount = exports.uccFlexLargePurchaseAdviceUpgradePolicy = exports.moapStarbucksFiftyDollarCreditUpgradePolicy = exports.moapStarbucksUpgradePolicy = exports.uccStarbucksFiftyDollarCreditUpgradePolicy = exports.uccStarbucksUpgradePolicy = exports.defaultMoap = exports.defaultAvenCash = exports.defaultMortgageRefi = exports.upgradeAvenCashWithBTSavingsGuarantee = exports.moapInterestRebate1000DM = exports.moapBucket3PctCBOn100KFloorPlus100bps = exports.upgradeAvenCashMatchPqAprInterestRebate1000 = exports.upgradeAvenCash3PctCBOriginalPricing = exports.upgradeAvenCash3PctCBWithOTB = exports.upgradeAvenCashOneYearOfStarbucksPromo = exports.upgradeAvenCashZeroPctFirstDrawFee = exports.upgradeAvenCash = exports.upgradeAvenCashMatchPqApr = exports.uccFlex = exports.defaultUcc = exports.defaultHelocRefiUpgrade = exports.starbucksMoapUpgrade = exports.defaultFlexToMoapUpgrade = exports.defaultUccToHomeUpgradePolicyName = void 0;
exports.getAuthenticatedUpgradeLinkPath = exports.getUpgradeLinkPath = void 0;
// As of 2026-05-20, the default home upgrade policy is post2026MayHomeUpgradeMoap (aka MOAMP)
exports.defaultUccToHomeUpgradePolicyName = 'defaultUccToHomeUpgradePolicyName';
exports.defaultFlexToMoapUpgrade = 'post2026JulFlexToMOAPUpgrade';
exports.starbucksMoapUpgrade = 'post2025JuneOneYearOfStarbucksPromotion';
// Used for ucc -> heloc refi upgrade policy
exports.defaultHelocRefiUpgrade = 'post2026JanMoapBucketHelocRefi';
// used for advisor -> ucc upgrade
exports.defaultUcc = 'defaultUcc';
exports.uccFlex = 'post2025SepUccFixedTermHomeImprovementWithFirstDrawFee';
// This policy is an Aven Cash policy, but also enables matching stated usage and cash out amount
// to make sure applicants see an offer that matches the stated usage they typed in.
exports.upgradeAvenCashMatchPqApr = 'post2026MayUpgradeToAvenCashMatchPqApr';
// upgradeAvenCashMatchPqApr is now the default for MOAP -> Aven Cash updates. Using this redirection allows us to properly cover all testing paths that previously relied on non matching APRs
exports.upgradeAvenCash = exports.upgradeAvenCashMatchPqApr;
exports.upgradeAvenCashZeroPctFirstDrawFee = 'post2026JulUpgradeToAvenCashZeroPctFirstDrawFee';
exports.upgradeAvenCashOneYearOfStarbucksPromo = 'post2025OctAvenCashOneYearOfStarbucksPromo';
exports.upgradeAvenCash3PctCBWithOTB = 'post2026AprUpgradeToAvenCash3PctCBWithOTB';
exports.upgradeAvenCash3PctCBOriginalPricing = 'post2026AprUpgradeToAvenCash3PctCBOriginalPricing';
exports.upgradeAvenCashMatchPqAprInterestRebate1000 = 'post2026MayUpgradeToAvenCashMatchPqAprInterestRebate1000';
// MOAP policy name for the +100bps floor experiment (used to detect treatment users in upgrade flow)
exports.moapBucket3PctCBOn100KFloorPlus100bps = 'post2026AprMoapBucket3PctCBOn100KFloorPlus100bps';
// MOAP DM policy name for the interest rebate experiment (used to detect treatment users in upgrade flow)
exports.moapInterestRebate1000DM = 'post2026MayMoapInterestRebate1000DM';
/**
 * Policy specifically for upgrades from MOAP policy w/ ENABLE_BALANCE_TRANSFER_SAVINGS_GUARANTEE = true.
 * Currently, the only policy that implements the guarantee is post2026JanMoapBucketWithBTSavingsGuaranteeDM.
 */
exports.upgradeAvenCashWithBTSavingsGuarantee = 'post2026JanAvenCashPRPPShadowLimitCHDTILimitWithBTSavingsGuaranteeDM';
exports.defaultMortgageRefi = 'defaultMortgageRefi';
exports.defaultAvenCash = 'defaultAvenCash';
exports.defaultMoap = 'default';
// policies for ucc/moap starbucks upsells
exports.uccStarbucksUpgradePolicy = 'post2025MarUccStarbucksDunkin5PctBoost';
exports.uccStarbucksFiftyDollarCreditUpgradePolicy = 'post2025AugUccFiftyDollarsOfStarbucksPolicy';
exports.moapStarbucksUpgradePolicy = 'post2025JunMoapStarbucksDunkin5PctBoost';
exports.moapStarbucksFiftyDollarCreditUpgradePolicy = 'post2025AugMoapFiftyDollarsOfStarbucksPolicy';
// policy for large purchase advice upsell
exports.uccFlexLargePurchaseAdviceUpgradePolicy = 'post2025SepAvenFlexForAvenAdvisor';
// These are the UTM campaigns for the Get Money fixed and custom amount buttons
exports.getMoneyFixedAmount = 'getMoneyFixedAmount';
exports.getMoneyCustomAmount = 'getMoneyCustomAmount';
// These are the UTM campaigns for the Get Money with One Year of Starbucks fixed and custom amount buttons
exports.getMoneyWithOneYearOfStarbucksFixedAmount = 'getMoneyWithOneYearOfStarbucksFixedAmount';
exports.getMoneyWithOneYearOfStarbucksCustomAmount = 'getMoneyWithOneYearOfStarbucksCustomAmount';
// This is the UTM campaign for the Boost Net Worth button
exports.boostNetWorthV0UtmCampaign = 'boostNetWorthV0UtmCampaign';
/** This enum represents the target LA to mark as duplicate when creating a new loan application */
var TargetToMarkAsDuplicate;
(function (TargetToMarkAsDuplicate) {
    /**
     * In this case, we won't mark any LA as duplicate, and may or may not create a new LA depending on if there's an existing LA.
     */
    TargetToMarkAsDuplicate["none"] = "none";
    /**
     * In this case, we'll always create a new loan application and mark all previous early stage upgrade LAs as duplicate, regardless of their policy.
     * This is the behaviour when a UCC cardholder is upgrading to home and we want to circumvent SELECT_APPLICATION if they only have early stage LAs
     */
    TargetToMarkAsDuplicate["everyPreviousPreNotarizationUpgradeLA"] = "everyPreviousPreNotarizationUpgradeLA";
    /** @deprecated, but keeping for logging purposes. Use everyPreviousPreNotarizationUpgradeLA instead */
    TargetToMarkAsDuplicate["_deprecatedPreviousUpgradeLoanApplication"] = "previousUpgradeLoanApplication";
    /**
     * In this case, we'll mark the original loan application that's passed into the method as duplicate in favor of
     * the upgrade application (a newly created one, or the existing upgrade application when one exists).
     */
    TargetToMarkAsDuplicate["originalLoanApplication"] = "originalLoanApplication";
    /**
     * In this case, if the phone or ssn of the LA we're upgrading from is associated with another active LA of the
     * same type as the upgrade, we'll mark it as duplicate, and replace it w/ a new one.
     */
    TargetToMarkAsDuplicate["furthestProgressedNonDryrunForPhoneOrSsn"] = "furthestProgressedNonDryrunForPhoneOrSsn";
    /**
     * For HIL applications: sweep all prior loan applications by the applicant's phone/SSN within
     * the same asset group and mark them duplicate, except priors that have ever reached
     * notarizationsComplete or have an associated open account. Used so partners can re-apply for
     * a higher credit limit without ops manually cancelling stale prior HIL LAs.
     *
     * Pass this when the new loan application is HIL (uw policy IS_HIL = true). It is a no-op for
     * non-HIL LAs.
     */
    TargetToMarkAsDuplicate["allNonExemptPriorsForHil"] = "allNonExemptPriorsForHil";
})(TargetToMarkAsDuplicate || (exports.TargetToMarkAsDuplicate = TargetToMarkAsDuplicate = {}));
/** This enum represents how much info to fill in the new loan application, given the upgrading entity */
var NewLoanApplicationFillInInfo;
(function (NewLoanApplicationFillInInfo) {
    /** Fill in as much info as possible to send the user to PQ */
    NewLoanApplicationFillInInfo["all"] = "all";
    /** Fill in phone number to send the user to PII page. */
    NewLoanApplicationFillInInfo["phoneNumberOnly"] = "phoneNumberOnly";
    /** Fill in all except home ownership and marital status. */
    NewLoanApplicationFillInInfo["allExceptHomeOwnershipAndMaritalStatus"] = "allExceptHomeOwnershipAndMaritalStatus";
})(NewLoanApplicationFillInInfo || (exports.NewLoanApplicationFillInInfo = NewLoanApplicationFillInInfo = {}));
var LoanApplicationCreationType;
(function (LoanApplicationCreationType) {
    LoanApplicationCreationType["new"] = "new";
    LoanApplicationCreationType["existing"] = "existing";
})(LoanApplicationCreationType || (exports.LoanApplicationCreationType = LoanApplicationCreationType = {}));
var StatedUsageAmountType;
(function (StatedUsageAmountType) {
    /** Use the max line size from policy as the stated usage amount. */
    StatedUsageAmountType["policyMaxLineSize"] = "policyMaxLineSize";
    /** Use the stated usage amount from the query params */
    StatedUsageAmountType["customAmount"] = "customAmount";
    /** UCC->Home upgrade placeholder: write a small fixed non-query-param amount. */
    StatedUsageAmountType["uccToHomePlaceholder"] = "uccToHomePlaceholder";
    /** Use a custom amount and same stated usage type as original loan application */
    StatedUsageAmountType["customAmountWithOriginalStatedUsageType"] = "customAmountWithOriginalStatedUsageType";
    /** Use the amount and type from the original loan application we're copying */
    StatedUsageAmountType["fromOriginalLoanApplication"] = "fromOriginalLoanApplication";
})(StatedUsageAmountType || (exports.StatedUsageAmountType = StatedUsageAmountType = {}));
var UpgradeCardFootnoteType;
(function (UpgradeCardFootnoteType) {
    UpgradeCardFootnoteType["genericWithForeclosureProtection"] = "genericWithForeclosureProtection";
    UpgradeCardFootnoteType["genericWithMonthlyPaymentCalc"] = "genericWithMonthlyPaymentCalc";
    UpgradeCardFootnoteType["genericAssumesCashDraw"] = "genericAssumesCashDraw";
    UpgradeCardFootnoteType["genericSubjectToCreditApproval"] = "genericSubjectToCreditApproval";
    UpgradeCardFootnoteType["genericNoCostNoObligationSubjectToCreditApproval"] = "genericNoCostNoObligationSubjectToCreditApproval";
    UpgradeCardFootnoteType["dryrunWithHelocGuaranteedApr"] = "dryrunWithHelocGuaranteedApr";
    UpgradeCardFootnoteType["dryrunWithVariableAndFixedProducts"] = "dryrunWithVariableAndFixedProducts";
    UpgradeCardFootnoteType["dryrunWithCashBackPromotion"] = "dryrunWithCashBackPromotion";
    UpgradeCardFootnoteType["dryrunWithCashBackPromotionSecond"] = "dryrunWithCashBackPromotionSecond";
    UpgradeCardFootnoteType["dryrunAvenCash"] = "dryrunAvenCash";
    UpgradeCardFootnoteType["getMoneySpecific"] = "getMoneySpecific";
    UpgradeCardFootnoteType["dryrunHelocRefiMonthlyPayment"] = "dryrunHelocRefiMonthlyPayment";
    UpgradeCardFootnoteType["getMoneyWithOneYearOfStarbucksSpecific"] = "getMoneyWithOneYearOfStarbucksSpecific";
    UpgradeCardFootnoteType["starbucksMoapSpecific"] = "starbucksMoapSpecific";
    UpgradeCardFootnoteType["postFlexCashOutUpgradeSpecific"] = "postFlexCashOutUpgradeSpecific";
    UpgradeCardFootnoteType["postFlexCashOutHomeFootnote"] = "postFlexCashOutHomeFootnote";
})(UpgradeCardFootnoteType || (exports.UpgradeCardFootnoteType = UpgradeCardFootnoteType = {}));
// This enum represents the type of upgrade card we will show to UCC cardholders in aven my and advisor users
var UpgradeCardType;
(function (UpgradeCardType) {
    UpgradeCardType["balanceDetailsBeard"] = "balanceDetailsBeard";
    UpgradeCardType["hilRewardsToHomeWithPayoffSweep"] = "hilRewardsToHome";
    /** Rewards-to-Home-only (not Flex). Named "ucc" for backcompat. */
    UpgradeCardType["uccBalanceTransferTeaserPreExpiration"] = "uccBalanceTransferTeaserPreExpiration";
    /** Rewards-to-Home-only (not Flex). Named "ucc" for backcompat. */
    UpgradeCardType["uccBalanceTransferTeaserPostExpiration"] = "uccBalanceTransferTeaserPostExpiration";
    UpgradeCardType["creditCardBalanceTransfer"] = "creditCardBalanceTransfer";
    UpgradeCardType["personalLoanRefi"] = "personalLoanRefi";
    UpgradeCardType["genericAvenCash"] = "genericAvenCash";
    UpgradeCardType["genericMoap"] = "genericMoap";
    UpgradeCardType["genericMoapVideoInterstitial"] = "genericMoapVideoInterstitial";
    UpgradeCardType["dryrunMoap"] = "dryrunMoap";
    UpgradeCardType["dryrunHelocRefi"] = "dryrunHelocRefi";
    UpgradeCardType["homeEquityFocusDryrunMoap"] = "homeEquityFocusDryrunMoap";
    UpgradeCardType["postFlexCashOutDryrunMoap"] = "postFlexCashOutDryrunMoap";
    UpgradeCardType["flexToHomeActivityDryrunMoap"] = "flexToHomeActivityDryrunMoap";
    UpgradeCardType["flexToHomePlTransferDryrunMoap"] = "flexToHomePlTransferDryrunMoap";
    UpgradeCardType["mortgageRefi"] = "mortgageRefi";
    UpgradeCardType["signNowMoap"] = "signNowMoap";
    UpgradeCardType["getMoney"] = "getMoney";
    UpgradeCardType["getMoneyWithOneYearOfStarbucks"] = "getMoneyWithOneYearOfStarbucks";
    UpgradeCardType["genericStarbucksMoap"] = "genericStarbucksMoap";
    UpgradeCardType["uccMoapStarbucks"] = "uccMoapStarbucks";
    UpgradeCardType["uccMoapStarbucksFiftyDollarCredit"] = "uccMoapStarbucksFiftyDollarCredit";
    UpgradeCardType["uccFlexLargePurchaseAdvice"] = "uccFlexLargePurchaseAdvice";
    UpgradeCardType["helocRefiGuaranteedBeat"] = "helocRefiGuaranteedBeat";
    /** Rewards-to-Home-only (not Flex). Named "ucc" for backcompat. */
    UpgradeCardType["uccToHomeGuaranteedAprBeat"] = "uccToHomeGuaranteedAprBeat";
    /** Rewards-to-Home-only (not Flex). Named "ucc" for backcompat. */
    UpgradeCardType["uccToHomeActivityCardCarousel"] = "uccToHomeActivityCardCarousel";
    /** Rewards-to-Home-only (not Flex). Named "ucc" for backcompat. */
    UpgradeCardType["uccToHomeCashBackSideBySide"] = "uccToHomeCashBackSideBySide";
    UpgradeCardType["boostNetWorth"] = "boostNetWorth";
    UpgradeCardType["flexToHomeInterestSavedUpgrade"] = "flexToHomeInterestSavedUpgrade";
    UpgradeCardType["advisorGenericDeposit"] = "advisorGenericDeposit";
    UpgradeCardType["homeDeniedDeposit"] = "homeDeniedDeposit";
    /** The balance-details beard Rewards BT upsell card. */
    UpgradeCardType["rewardsBtUpsellBalanceDetailsBeard"] = "rewardsBtUpsellBalanceDetailsBeard";
    /** The recurring in-app (activity feed) Rewards BT upsell card. */
    UpgradeCardType["rewardsBtUpsellInApp"] = "rewardsBtUpsellInApp";
    // TODO: the stored value keeps the original bundle name. Renaming it needs a backfill of ad_creative.creative_type and upgrade_data_report.upgrade_card_type.
    /** The activity feed card upselling a Rewards cardholder into the cashback boost deposit bundle */
    UpgradeCardType["cashbackBoostDepositBundleUpsell"] = "rewardsDepositBundleUpsell";
    UpgradeCardType["none"] = "none";
})(UpgradeCardType || (exports.UpgradeCardType = UpgradeCardType = {}));
var UpgradeCardTypeDeprecated;
(function (UpgradeCardTypeDeprecated) {
    /**
     * Refers to the deprecated upgrade offer initiated in upgradeOffersStore.ts. Eventually this
     * way to get an upgrade offer will be removed, replaced completely w/ adDeliveryManager.
     * @deprecated
     */
    UpgradeCardTypeDeprecated["moampUpgrade"] = "moampUpgrade";
    /**
     * Corresponds to CostcoUpgradeFeedUnit.vue
     * @deprecated
     */
    UpgradeCardTypeDeprecated["costcoUpgradeFeedUnit"] = "costcoUpgradeFeedUnit";
})(UpgradeCardTypeDeprecated || (exports.UpgradeCardTypeDeprecated = UpgradeCardTypeDeprecated = {}));
/** @TranslateToPython */
var UpgradePage;
(function (UpgradePage) {
    /** Corresponds to PreQualification.vue */
    UpgradePage["preQualification"] = "preQualification";
    /** Corresponds to PostPreQualificationUpgrade.vue */
    UpgradePage["postPreQualificationUpgrade"] = "postPreQualificationUpgrade";
    /** Corresponds to UccUpgradeToHomePage.vue */
    UpgradePage["uccUpgradeToHome"] = "uccUpgradeToHome";
    /** Corresponds to UccWelcomePage.vue */
    UpgradePage["uccWelcomePage"] = "uccWelcomePage";
    /** Corresponds to pre qualification for the UCC + Home bundle */
    UpgradePage["uccHomeBundle"] = "uccHomeBundle";
    /** Corresponds to FirstLienAttestation.vue */
    UpgradePage["firstLienAttestationUpgrade"] = "firstLienAttestationUpgrade";
    /** Corresponds to FirstLienPrePqUpgrade.vue */
    UpgradePage["firstLienPrePqUpgrade"] = "firstLienPrePqUpgrade";
    /** Corresponds to FirstLienUpgrade.vue */
    UpgradePage["firstLienUpgrade"] = "firstLienUpgrade";
    /** Corresponds to NotarySession.vue */
    UpgradePage["notarySessionUpgrade"] = "notarySessionUpgrade";
    /** Corresponds to AvenHomeCardUpgrade.vue */
    UpgradePage["avenHomeCardUpgrade"] = "avenHomeCardUpgrade";
    /** Home-to-deposit upsell flow in aven_my */
    UpgradePage["homeToDepositUpsell"] = "homeToDepositUpsell";
    /** HIL Home-equity denial -> HIL Rewards (UCC) downgrade offer on UnapprovedPage.vue */
    UpgradePage["hilHomeDeniedRewardsDowngrade"] = "hilHomeDeniedRewardsDowngrade";
    // TODO: the stored values of the three bundle upgrade pages below keep the original bundle names. Renaming them needs a backfill of loan_application.upgrade_source.
    UpgradePage["hilHomeGeographyBlockedRewardsAlternative"] = "hilHomeGeographyBlockedRewardsAlternative";
    /** Opening Aven Checking from the cashback boost deposit bundle approval screen */
    UpgradePage["cashbackBoostDepositBundleOpenChecking"] = "rewardsCheckingBundleOpenChecking";
    /** Opening Aven Checking from the cashback boost deposit bundle upsell shown to existing Rewards cardholders in aven_my */
    UpgradePage["cashbackBoostDepositBundleUpsellOpenChecking"] = "rewardsDepositBundleUpsellOpenChecking";
    UpgradePage["aprDiscountDepositBundleOpenHighYieldChecking"] = "homeDepositBundleOpenHighYieldChecking";
})(UpgradePage || (exports.UpgradePage = UpgradePage = {}));
var UpgradeOpsEndpoint;
(function (UpgradeOpsEndpoint) {
    /** Corresponds to opsHomeUpgradeDryrun() */
    UpgradeOpsEndpoint["opsHomeUpgradeEndpoint"] = "opsHomeUpgradeEndpoint";
    /** Corresponds to opsUccToHelocRefiUpgradeDryrun() */
    UpgradeOpsEndpoint["opsUccToHelocRefiUpgradeEndpoint"] = "opsUccToHelocRefiUpgradeEndpoint";
    /** Corresponds to createNewLoanApplicationFromExistingLoanApplicationAndTriggerPQUW */
    UpgradeOpsEndpoint["opsCreateNewLoanApplicationFromExistingLoanApplicationAndTriggerPQUW"] = "opsCreateNewLoanApplicationFromExistingLoanApplicationAndTriggerPQUW";
})(UpgradeOpsEndpoint || (exports.UpgradeOpsEndpoint = UpgradeOpsEndpoint = {}));
var UpgradeBackgroundProcess;
(function (UpgradeBackgroundProcess) {
    /** Corresponds to balanceTransferTeaserExpirationManager.ts queueDryRunForTeaserCommunications() */
    UpgradeBackgroundProcess["balanceTransferTeaserExpiration"] = "balanceTransferTeaserExpiration";
    /** Corresponds to statusSideEffectStatusTransitionListener.ts triggerIncompleteSideEffects() */
    UpgradeBackgroundProcess["incompleteStatusSideEffect"] = "incompleteStatusSideEffect";
    /** Corresponds to teaserExpirationDrip.ts */
    UpgradeBackgroundProcess["teaserExpirationDrip"] = "teaserExpirationDrip";
    /** Corresponds to homeUpgradeDryrunDaemonJobQueue.ts - creates dry runs at scheduled intervals (month 4, 8, 12, etc.) */
    UpgradeBackgroundProcess["scheduledDryrunDaemon"] = "scheduledDryrunDaemon";
    /** Corresponds to offerEligibilityAutoCheckDaemonController.ts - daily re-UW check for denied applicants who opened deposit accounts */
    UpgradeBackgroundProcess["offerEligibilityAutoCheck"] = "offerEligibilityAutoCheck";
    /** Corresponds to helocDeniedMortgageUpgradeTransitionListener.ts - proactive mortgage upgrade after HELOC denial */
    UpgradeBackgroundProcess["deniedStatusSideEffect"] = "deniedStatusSideEffect";
})(UpgradeBackgroundProcess || (exports.UpgradeBackgroundProcess = UpgradeBackgroundProcess = {}));
var UpgradeSourceUnknown;
(function (UpgradeSourceUnknown) {
    /**
     * Used when we don't know the source. Ideally this will be noticed in
     * our dashboards & accompanying PD alerts and replaced w/ a known source.
     */
    UpgradeSourceUnknown["unknown"] = "unknown";
    /**
     * Used when we know the upgrade process is for ThirdPartyLeads, but we
     * don't have more specific information. Ideally this will be noticed in
     * our dashboards & accompanying PD alerts and replaced w/ a known source.
     */
    UpgradeSourceUnknown["unknownThirdPartyLead"] = "unknownThirdPartyLead";
    /**
     * Used when we know the upgrade process is for mortgage, but we
     * don't have more specific information. Ideally this will be noticed in
     * our dashboards & accompanying PD alerts and replaced w/ a known source.
     */
    UpgradeSourceUnknown["unknownMortgage"] = "unknownMortgage";
})(UpgradeSourceUnknown || (exports.UpgradeSourceUnknown = UpgradeSourceUnknown = {}));
exports.UPGRADE_SOURCE_VALUES = [
    ...Object.values(UpgradeCardType),
    ...Object.values(UpgradePage),
    ...Object.values(UpgradeOpsEndpoint),
    ...Object.values(UpgradeBackgroundProcess),
    ...Object.values(UpgradeCardTypeDeprecated),
    ...Object.values(UpgradeSourceUnknown),
];
const isUpgradeSource = (candidate) => {
    return exports.UPGRADE_SOURCE_VALUES.includes(candidate);
};
exports.isUpgradeSource = isUpgradeSource;
var UpgradeCardOfferType;
(function (UpgradeCardOfferType) {
    UpgradeCardOfferType["specificDryRunOffer"] = "specificDryRunOffer";
    UpgradeCardOfferType["generic"] = "generic";
    UpgradeCardOfferType["none"] = "none";
})(UpgradeCardOfferType || (exports.UpgradeCardOfferType = UpgradeCardOfferType = {}));
exports.UpgradeCardAttributeRecord = {
    [UpgradeCardType.balanceDetailsBeard]: {
        advisorToUcc: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        validForUpgradeCardDrip: false,
        advisorToHome: false,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.dryrunWithCashBackPromotion,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.hilRewardsToHomeWithPayoffSweep]: {
        advisorToUcc: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        validForUpgradeCardDrip: false,
        advisorToHome: false,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.genericSubjectToCreditApproval,
        deferForAvenFlexUntilActivationRequirementMet: false,
    },
    [UpgradeCardType.uccBalanceTransferTeaserPreExpiration]: {
        validForUpgradeCardDrip: false,
        advisorToHome: false,
        advisorToUcc: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.dryrunAvenCash,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.uccBalanceTransferTeaserPostExpiration]: {
        validForUpgradeCardDrip: false,
        advisorToHome: false,
        advisorToUcc: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.dryrunAvenCash,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.creditCardBalanceTransfer]: {
        advisorToUcc: false,
        offerType: UpgradeCardOfferType.generic,
        validForUpgradeCardDrip: true,
        advisorToHome: true,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.genericWithMonthlyPaymentCalc,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.personalLoanRefi]: {
        advisorToUcc: false,
        offerType: UpgradeCardOfferType.generic,
        validForUpgradeCardDrip: true,
        advisorToHome: true,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.genericWithForeclosureProtection,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.genericAvenCash]: {
        advisorToUcc: false,
        offerType: UpgradeCardOfferType.generic,
        validForUpgradeCardDrip: true,
        advisorToHome: true,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.genericAssumesCashDraw,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.genericMoap]: {
        advisorToUcc: false,
        validForUpgradeCardDrip: false,
        uccToHome: false,
        offerType: UpgradeCardOfferType.generic,
        advisorToHome: true,
        footnotesType: UpgradeCardFootnoteType.genericSubjectToCreditApproval,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.genericMoapVideoInterstitial]: {
        advisorToUcc: false,
        validForUpgradeCardDrip: false,
        uccToHome: false,
        offerType: UpgradeCardOfferType.generic,
        advisorToHome: true,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.dryrunHelocRefi]: {
        advisorToUcc: false,
        validForUpgradeCardDrip: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        advisorToHome: false,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.dryrunHelocRefiMonthlyPayment,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.dryrunMoap]: {
        advisorToUcc: false,
        validForUpgradeCardDrip: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        advisorToHome: true,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.dryrunWithCashBackPromotionSecond,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.homeEquityFocusDryrunMoap]: {
        advisorToUcc: false,
        validForUpgradeCardDrip: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        // Todo In the future, enable this card for Advisor too.
        advisorToHome: false,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.dryrunWithVariableAndFixedProducts,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.postFlexCashOutDryrunMoap]: {
        advisorToUcc: false,
        validForUpgradeCardDrip: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        // Todo In the future, enable this card for Advisor too.
        advisorToHome: false,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.postFlexCashOutUpgradeSpecific,
        deferForAvenFlexUntilActivationRequirementMet: false,
    },
    [UpgradeCardType.flexToHomeActivityDryrunMoap]: {
        advisorToUcc: false,
        validForUpgradeCardDrip: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        advisorToHome: false,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.postFlexCashOutUpgradeSpecific,
        // This is false because the card handles its own eligibility check for post-activation Flex users
        deferForAvenFlexUntilActivationRequirementMet: false,
    },
    [UpgradeCardType.flexToHomePlTransferDryrunMoap]: {
        advisorToUcc: false,
        validForUpgradeCardDrip: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        advisorToHome: false,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.postFlexCashOutUpgradeSpecific,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.mortgageRefi]: {
        advisorToUcc: false,
        validForUpgradeCardDrip: false,
        uccToHome: false,
        offerType: UpgradeCardOfferType.generic,
        advisorToHome: true,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.signNowMoap]: {
        advisorToUcc: false,
        validForUpgradeCardDrip: false,
        uccToHome: false,
        offerType: UpgradeCardOfferType.generic,
        advisorToHome: true,
        footnotesType: UpgradeCardFootnoteType.genericNoCostNoObligationSubjectToCreditApproval,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.getMoney]: {
        advisorToUcc: false,
        validForUpgradeCardDrip: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        advisorToHome: true,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.getMoneySpecific,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.getMoneyWithOneYearOfStarbucks]: {
        advisorToUcc: false,
        validForUpgradeCardDrip: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        advisorToHome: true,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.getMoneyWithOneYearOfStarbucksSpecific,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.genericStarbucksMoap]: {
        advisorToUcc: false,
        validForUpgradeCardDrip: false,
        uccToHome: false,
        offerType: UpgradeCardOfferType.generic,
        advisorToHome: true,
        footnotesType: UpgradeCardFootnoteType.starbucksMoapSpecific,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.uccMoapStarbucks]: {
        validForUpgradeCardDrip: false,
        uccToHome: false,
        advisorToHome: false,
        offerType: UpgradeCardOfferType.generic,
        advisorToUcc: true,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.uccMoapStarbucksFiftyDollarCredit]: {
        validForUpgradeCardDrip: false,
        uccToHome: false,
        advisorToHome: false,
        offerType: UpgradeCardOfferType.generic,
        advisorToUcc: true,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.uccFlexLargePurchaseAdvice]: {
        validForUpgradeCardDrip: false,
        uccToHome: false,
        advisorToHome: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        advisorToUcc: true,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.helocRefiGuaranteedBeat]: {
        validForUpgradeCardDrip: false,
        uccToHome: false,
        advisorToHome: true,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        advisorToUcc: false,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.uccToHomeGuaranteedAprBeat]: {
        validForUpgradeCardDrip: false,
        uccToHome: true,
        advisorToHome: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        advisorToUcc: false,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.uccToHomeActivityCardCarousel]: {
        validForUpgradeCardDrip: false,
        uccToHome: true,
        advisorToHome: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        advisorToUcc: false,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.uccToHomeCashBackSideBySide]: {
        validForUpgradeCardDrip: false,
        uccToHome: true,
        advisorToHome: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        advisorToUcc: false,
        footnotesType: UpgradeCardFootnoteType.dryrunWithCashBackPromotion,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.boostNetWorth]: {
        validForUpgradeCardDrip: false,
        uccToHome: false,
        advisorToHome: true,
        offerType: UpgradeCardOfferType.generic, // Technically could be both specific and generic, but we'll default to generic for now
        advisorToUcc: false,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.flexToHomeInterestSavedUpgrade]: {
        advisorToUcc: false,
        validForUpgradeCardDrip: false,
        offerType: UpgradeCardOfferType.specificDryRunOffer,
        advisorToHome: false,
        uccToHome: true,
        footnotesType: UpgradeCardFootnoteType.postFlexCashOutUpgradeSpecific,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
    [UpgradeCardType.advisorGenericDeposit]: {
        validForUpgradeCardDrip: false,
        uccToHome: false,
        advisorToHome: false,
        offerType: UpgradeCardOfferType.generic,
        advisorToUcc: false,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: false,
    },
    [UpgradeCardType.homeDeniedDeposit]: {
        validForUpgradeCardDrip: false,
        uccToHome: false,
        advisorToHome: false,
        offerType: UpgradeCardOfferType.generic,
        advisorToUcc: false,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: false,
    },
    [UpgradeCardType.rewardsBtUpsellBalanceDetailsBeard]: {
        validForUpgradeCardDrip: false,
        uccToHome: false,
        advisorToHome: false,
        offerType: UpgradeCardOfferType.generic,
        advisorToUcc: false,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: false,
    },
    [UpgradeCardType.rewardsBtUpsellInApp]: {
        validForUpgradeCardDrip: false,
        uccToHome: false,
        advisorToHome: false,
        offerType: UpgradeCardOfferType.generic,
        advisorToUcc: false,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: false,
    },
    [UpgradeCardType.cashbackBoostDepositBundleUpsell]: {
        validForUpgradeCardDrip: false,
        uccToHome: false,
        advisorToHome: false,
        offerType: UpgradeCardOfferType.generic,
        advisorToUcc: false,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: false,
    },
    [UpgradeCardType.none]: {
        validForUpgradeCardDrip: false,
        offerType: UpgradeCardOfferType.none,
        advisorToHome: false,
        advisorToUcc: false,
        uccToHome: false,
        footnotesType: null,
        deferForAvenFlexUntilActivationRequirementMet: true,
    },
};
var BalanceDetailsBeardVariant;
(function (BalanceDetailsBeardVariant) {
    BalanceDetailsBeardVariant["beardAprVariant"] = "uccDisplayCardBeardAprVariant";
    BalanceDetailsBeardVariant["beardMonthlyPaymentVariant"] = "uccDisplayCardBeardMonthlyPaymentVariant";
    BalanceDetailsBeardVariant["beardLineSizeVariant"] = "uccDisplayCardBeardLineSizeVariant";
    BalanceDetailsBeardVariant["beardCashBackVariant"] = "uccDisplayCardBeardCashBackVariant";
})(BalanceDetailsBeardVariant || (exports.BalanceDetailsBeardVariant = BalanceDetailsBeardVariant = {}));
var BalanceDetailsBeardUpgradeUIVariant;
(function (BalanceDetailsBeardUpgradeUIVariant) {
    // The default UCC path uses the default copy and the standard UCC Home upgrade policy.
    BalanceDetailsBeardUpgradeUIVariant["uccToHome"] = "uccToHome";
    // HIL Rewards uses "next home project" copy and a HIL Home upgrade policy
    BalanceDetailsBeardUpgradeUIVariant["hilRewardsToHome"] = "hilRewardsToHome";
})(BalanceDetailsBeardUpgradeUIVariant || (exports.BalanceDetailsBeardUpgradeUIVariant = BalanceDetailsBeardUpgradeUIVariant = {}));
var GenericMoapVideoInterstitialTrustBuilderComponent;
(function (GenericMoapVideoInterstitialTrustBuilderComponent) {
    GenericMoapVideoInterstitialTrustBuilderComponent["creditCardFrontHomeEquityBack"] = "creditCardFrontHomeEquityBack";
    GenericMoapVideoInterstitialTrustBuilderComponent["creditCardForHomeowners"] = "creditCardForHomeowners";
    GenericMoapVideoInterstitialTrustBuilderComponent["guaranteedForeclosureProtection"] = "guaranteedForeclosureProtection";
    GenericMoapVideoInterstitialTrustBuilderComponent["affordableAndRewardingCredit"] = "affordableAndRewardingCredit";
})(GenericMoapVideoInterstitialTrustBuilderComponent || (exports.GenericMoapVideoInterstitialTrustBuilderComponent = GenericMoapVideoInterstitialTrustBuilderComponent = {}));
// This map is used to get the slug for the embedded ad url for the given upgrade card type
exports.UPGRADE_CARD_TYPE_TO_EMBEDDED_AD_URL_SLUG_MAP = {
    [UpgradeCardType.balanceDetailsBeard]: 'green_beard',
    [UpgradeCardType.hilRewardsToHomeWithPayoffSweep]: 'hil_rewards_to_home',
    [UpgradeCardType.genericMoap]: 'generic_moap',
    [UpgradeCardType.genericMoapVideoInterstitial]: 'generic_moap_video_interstitial',
    [UpgradeCardType.genericAvenCash]: 'generic_aven_cash',
    [UpgradeCardType.creditCardBalanceTransfer]: 'credit_card_balance_transfer',
    [UpgradeCardType.personalLoanRefi]: 'personal_loan_refi',
    [UpgradeCardType.dryrunHelocRefi]: 'dryrun_heloc_refi',
    [UpgradeCardType.dryrunMoap]: 'dryrun_moap',
    [UpgradeCardType.homeEquityFocusDryrunMoap]: 'home_equity_focus_dryrun',
    [UpgradeCardType.postFlexCashOutDryrunMoap]: 'post_flex_cash_out_dryrun',
    [UpgradeCardType.flexToHomeActivityDryrunMoap]: 'flex_to_home_activity_dryrun',
    [UpgradeCardType.flexToHomePlTransferDryrunMoap]: 'flex_to_home_pl_transfer_dryrun',
    [UpgradeCardType.mortgageRefi]: 'mortgage_refi',
    [UpgradeCardType.signNowMoap]: 'sign_now_moap',
    [UpgradeCardType.getMoney]: 'get_money',
    [UpgradeCardType.getMoneyWithOneYearOfStarbucks]: 'get_money_with_one_year_of_starbucks',
    [UpgradeCardType.genericStarbucksMoap]: 'generic_starbucks_moap',
    [UpgradeCardType.uccMoapStarbucks]: 'ucc_moap_starbucks',
    [UpgradeCardType.uccMoapStarbucksFiftyDollarCredit]: 'ucc_moap_starbucks_50_dollar_credit',
    [UpgradeCardType.uccBalanceTransferTeaserPostExpiration]: 'ucc_balance_transfer_teaser_post_expiration',
    [UpgradeCardType.uccBalanceTransferTeaserPreExpiration]: 'ucc_balance_transfer_teaser_pre_expiration',
    [UpgradeCardType.uccFlexLargePurchaseAdvice]: 'ucc_flex_large_purchase_advice',
    [UpgradeCardType.helocRefiGuaranteedBeat]: 'heloc_refi_guaranteed_beat',
    [UpgradeCardType.uccToHomeGuaranteedAprBeat]: 'ucc_to_home_guaranteed_apr_beat',
    [UpgradeCardType.uccToHomeActivityCardCarousel]: 'ucc_to_home_activity_card_carousel',
    [UpgradeCardType.uccToHomeCashBackSideBySide]: 'ucc_to_home_cash_back_side_by_side',
    [UpgradeCardType.boostNetWorth]: 'boost_net_worth',
    [UpgradeCardType.flexToHomeInterestSavedUpgrade]: 'flex_to_home_interest_saved_upgrade',
    [UpgradeCardType.advisorGenericDeposit]: 'advisor_generic_deposit',
    [UpgradeCardType.homeDeniedDeposit]: 'home_denied_deposit',
    [UpgradeCardType.rewardsBtUpsellBalanceDetailsBeard]: 'rewards_bt_upsell_balance_details_beard',
    [UpgradeCardType.rewardsBtUpsellInApp]: 'rewards_bt_upsell_in_app',
    // TODO: the slug keeps the original bundle name because it is part of the embedded ad url. Rename it behind a redirect.
    [UpgradeCardType.cashbackBoostDepositBundleUpsell]: 'rewards_deposit_bundle_upsell',
};
// Reverse the map above
exports.EMBEDDED_AD_URL_SLUG_TO_UPGRADE_CARD_TYPE_MAP = Object.fromEntries(Object.entries(exports.UPGRADE_CARD_TYPE_TO_EMBEDDED_AD_URL_SLUG_MAP)
    .map(([key, value]) => [value, key])
    // filter out null values
    .filter(([_, value]) => value !== null));
var UpgradePaths;
(function (UpgradePaths) {
    UpgradePaths["assetToHome"] = "asset_to_home";
    UpgradePaths["newLoanApplication"] = "new_loan_application";
})(UpgradePaths || (exports.UpgradePaths = UpgradePaths = {}));
const getUpgradeLinkParts = ({ upgradePath = UpgradePaths.assetToHome, returnToken2, upgradeUwPolicyName, utmSource, utmSourceInternal, utmCampaign, utmContent, utmId, utmMedium, utmMerchantId, upgradeToken, upgradeSource, statedUsage, statedUsageAmountType, targetToMarkAsDuplicate, eSignPricingAndTerms, cleanReload = true, renderUid, newLoanApplicationFillInInfo, fallbackLandingPage, limitExistingLoanApplicationChecksToStatedUsageAmount, shouldShowReviewPage, competitorApr, proposalActionDetailsExternalId, flexCashoutAmount, targetFixedApr, targetFixedTermMonths, targetFixedMonthlyPayment, merchantDiscountRatePct, referrer, thirdPartyOfferGenerationType, prequalSliderSelectionId, }) => {
    const urlQueryParams = [
        `utm_campaign=${utmCampaign}`,
        `render_uid=${renderUid}`,
        newLoanApplicationFillInInfo ? `newLoanApplicationFillInInfo=${newLoanApplicationFillInInfo}` : undefined,
        utmSource ? `utm_source=${utmSource}` : undefined,
        utmSourceInternal ? `utm_source_internal=${utmSourceInternal}` : undefined,
        cleanReload ? 'cleanReload=true' : undefined,
        eSignPricingAndTerms ? `eSignPricingAndTerms=true` : undefined,
        utmContent ? `utm_content=${utmContent}` : undefined,
        utmId ? `utm_id=${utmId}` : undefined,
        utmMedium ? `utm_medium=${utmMedium}` : undefined,
        utmMerchantId ? `utm_merchant_id=${utmMerchantId}` : undefined,
        upgradeSource ? `upgradeSource=${upgradeSource}` : undefined,
        statedUsage ? `statedUsage=${statedUsage}` : undefined,
        statedUsageAmountType ? `statedUsageAmountType=${statedUsageAmountType}` : undefined,
        targetToMarkAsDuplicate ? `targetToMarkAsDuplicate=${targetToMarkAsDuplicate}` : undefined,
        prequalSliderSelectionId ? `prequalSliderSelectionId=${prequalSliderSelectionId}` : undefined,
        // We add upgradeToken at the end of the url in case it gets truncated by a length limit. This way, at least
        // the other parameters are maintained. The worst case scenario for a malformed upgradeToken is the applicant
        // will see the PQ page again for the AC upgrade.
        upgradeToken ? `upgradeToken=${upgradeToken}` : undefined,
        fallbackLandingPage ? `fallbackLandingPage=${fallbackLandingPage}` : undefined,
        limitExistingLoanApplicationChecksToStatedUsageAmount ? `limitExistingLoanApplicationChecksToStatedUsageAmount=true` : undefined,
        shouldShowReviewPage ? `shouldShowReviewPage=true` : undefined,
        competitorApr ? `competitorApr=${competitorApr}` : undefined,
        proposalActionDetailsExternalId ? `proposalActionDetailsExternalId=${proposalActionDetailsExternalId}` : undefined,
        flexCashoutAmount ? `flexCashoutAmount=${flexCashoutAmount}` : undefined,
        targetFixedApr ? `targetFixedApr=${targetFixedApr}` : undefined,
        targetFixedTermMonths ? `targetFixedTermMonths=${targetFixedTermMonths}` : undefined,
        targetFixedMonthlyPayment ? `targetFixedMonthlyPayment=${targetFixedMonthlyPayment}` : undefined,
        // Explicit undefined check, not truthiness: 0% is a valid merchant discount rate.
        merchantDiscountRatePct !== undefined ? `merchantDiscountRatePct=${merchantDiscountRatePct}` : undefined,
        referrer ? `referrer=${referrer}` : undefined,
        thirdPartyOfferGenerationType ? `thirdPartyOfferGenerationType=${thirdPartyOfferGenerationType}` : undefined,
    ].filter((param) => !!param);
    return { upgradePath, returnToken2, upgradeUwPolicyName, urlQueryParams };
};
const getUpgradeLinkPath = (options) => {
    const { upgradePath, returnToken2, upgradeUwPolicyName, urlQueryParams } = getUpgradeLinkParts(options);
    return `/origination/${upgradePath}/${returnToken2}/${btoa(upgradeUwPolicyName)}${urlQueryParams.length > 0 ? `?${urlQueryParams.filter(Boolean).join('&')}` : ''}`;
};
exports.getUpgradeLinkPath = getUpgradeLinkPath;
/** Save exact business context for treatment; an unprepared control keeps its original direct URL. */
const getAuthenticatedUpgradeLinkPath = async (options, prepare) => {
    const upgradePath = options.upgradePath ?? UpgradePaths.assetToHome;
    if (upgradePath === UpgradePaths.newLoanApplication && !options.sourceJwt) {
        return (0, exports.getUpgradeLinkPath)(options);
    }
    const { returnToken2, upgradeUwPolicyName, urlQueryParams } = getUpgradeLinkParts({ ...options, cleanReload: false });
    const query = new URLSearchParams(urlQueryParams.map((param) => {
        const separator = param.indexOf('=');
        return [param.slice(0, separator), param.slice(separator + 1)];
    }));
    const destinationUrl = `/origination/${upgradePath}/${encodeURIComponent(returnToken2)}/${encodeURIComponent(btoa(upgradeUwPolicyName))}${query.toString() ? `?${query.toString()}` : ''}`;
    const preparedUrl = await prepare({ returnToken: returnToken2, sourceJwt: options.sourceJwt, destinationUrl });
    return preparedUrl ?? (0, exports.getUpgradeLinkPath)(options);
};
exports.getAuthenticatedUpgradeLinkPath = getAuthenticatedUpgradeLinkPath;
